export const userIsGuest = user => {
    return Object.keys(user).length === 0 || !user.email;
};